export var packageVersion = '11.6.0';
